module.exports = __webpack_public_path__ + "143dcf2d60aa7f8858e318d9ef30ebba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/map.svg
// module id = 763
// module chunks = 0